var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __markAsModule = (target) => __defProp(target, "__esModule", { value: true });
var __export = (target, all) => {
  __markAsModule(target);
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __reExport = (target, module2, desc) => {
  if (module2 && typeof module2 === "object" || typeof module2 === "function") {
    for (let key of __getOwnPropNames(module2))
      if (!__hasOwnProp.call(target, key) && key !== "default")
        __defProp(target, key, { get: () => module2[key], enumerable: !(desc = __getOwnPropDesc(module2, key)) || desc.enumerable });
  }
  return target;
};
var __toModule = (module2) => {
  return __reExport(__markAsModule(__defProp(module2 != null ? __create(__getProtoOf(module2)) : {}, "default", module2 && module2.__esModule && "default" in module2 ? { get: () => module2.default, enumerable: true } : { value: module2, enumerable: true })), module2);
};
__export(exports, {
  ARG: () => ARG,
  evalArgs: () => evalArgs,
  fillingValue: () => fillingValue,
  getCountValue: () => getCountValue,
  isCondition: () => isCondition,
  operateMatrices: () => operateMatrices,
  operateMatricesOneToMany: () => operateMatricesOneToMany,
  operateMatrix: () => operateMatrix,
  sanitizeNumber: () => sanitizeNumber,
  sanitizeString: () => sanitizeString,
  simplify: () => simplify,
  uppercaseString: () => uppercaseString
});
var import_mathFunctionError = __toModule(require("../../../../../error/mathFunctionError"));
const ARG = {
  MATRIX: {
    BOOLEAN: [false],
    STRING: [""],
    NUMBER: [0]
  },
  SCALAR: {
    BOOLEAN: false,
    STRING: "",
    NUMBER: 0
  }
};
const evalArgs = (args, scope, defaultValueArg1, defaultValueArgs) => {
  return args.map((arg, index) => {
    if (scope[arg.name] !== void 0 || arg.fn || arg.value || arg.content) {
      const evaled = arg.compile().evaluate(scope);
      if (Array.isArray(evaled)) {
        return evaled.map((evaledScalar) => evaledScalar === void 0 ? defaultValueArg1 : evaledScalar);
      }
      if (evaled !== void 0) {
        return evaled;
      }
    }
    if (index === 0 || defaultValueArgs === void 0) {
      return defaultValueArg1;
    }
    return defaultValueArgs;
  });
};
const fillingValue = (value) => {
  if (Array.isArray(value)) {
    const isString = value.every((element) => {
      return typeof element === "string";
    });
    if (isString) {
      return ARG.SCALAR.STRING;
    }
  }
  if (typeof value === "string") {
    return ARG.SCALAR.STRING;
  }
  return ARG.SCALAR.NUMBER;
};
const getCountValue = (count, word) => {
  if (Number.isInteger(count) && count !== 0) {
    return count;
  }
  if (typeof word === "string" && (Number.isNaN(parseInt(count)) || count === 0)) {
    return word.length;
  }
  return parseInt(count);
};
const isCondition = (condition) => {
  if (!Array.isArray(condition)) {
    return condition === true;
  }
  return !condition.every((element) => {
    return element === false;
  });
};
const sanitizeNumberScalar = (value) => {
  if (typeof value !== "number") {
    if (typeof value === "boolean") {
      if (value) {
        return 1;
      }
      return ARG.SCALAR.NUMBER;
    }
    return Number.isNaN(parseFloat(value)) ? ARG.SCALAR.NUMBER : parseFloat(value);
  }
  return value;
};
const sanitizeNumber = (value, minArgs = 1) => {
  if (Array.isArray(value) && value.length >= minArgs) {
    return value.map((valueElement) => {
      if (Array.isArray(valueElement)) {
        return sanitizeNumber(valueElement);
      }
      return sanitizeNumberScalar(valueElement);
    });
  }
  if (minArgs > 1) {
    if (Array.isArray(value)) {
      const sanitized2 = value.concat(new Array(minArgs - value.length).fill(0));
      return sanitized2.map((valueElement) => sanitizeNumberScalar(valueElement));
    }
    const sanitized = [value].concat(new Array(minArgs - value.length).fill(0));
    return sanitized.map((valueElement) => sanitizeNumberScalar(valueElement));
  }
  return sanitizeNumberScalar(value);
};
const sanitizeStringScalar = (value) => {
  if (typeof value !== "string") {
    return ARG.SCALAR.STRING;
  }
  return value;
};
const sanitizeString = (value) => {
  if (Array.isArray(value)) {
    return value.map((valueElement) => sanitizeStringScalar(valueElement));
  }
  return sanitizeStringScalar(value);
};
const uppercaseString = (value) => {
  if (Array.isArray(value)) {
    return value.map((valueElement) => valueElement.toUpperCase());
  }
  return value.toUpperCase();
};
const operateMatrix = (runFunction, matrix, arg = null) => {
  if (!Array.isArray(matrix)) {
    if (arg == null) {
      return [runFunction(matrix)];
    }
    return [runFunction(matrix, arg)];
  }
  if (arg && Array.isArray(arg)) {
    const message = `Function ${runFunction.name}. Expected value but found matrix as argument: [${arg}]`;
    throw new import_mathFunctionError.MathFunctionError(message);
  }
  const minLength = matrix.length || 1;
  const resultMatrix = new Array(minLength);
  for (let i = 0; i < minLength; i += 1) {
    if (arg == null) {
      resultMatrix[i] = runFunction(matrix[i]);
    } else {
      resultMatrix[i] = runFunction(matrix[i], arg);
    }
  }
  return resultMatrix;
};
const operateScalars = (runFunction, matrixA, matrixB) => {
  if (matrixA === void 0 && matrixB === void 0) {
    return 0;
  } else if (matrixA === void 0) {
    return matrixB;
  } else if (matrixB === void 0) {
    return matrixA;
  }
  return runFunction(...[matrixA, matrixB]);
};
const operateMultipleMatrices = (runFunction, matrices) => {
  const validatedMatrices = matrices.map((matrix) => {
    return Array.isArray(matrix) ? matrix : [matrix];
  });
  const matrixLength = validatedMatrices[0].length;
  const resultMatrix = new Array(matrixLength);
  for (let i = 0; i < validatedMatrices.length; i += 1) {
    if (validatedMatrices[i].length !== matrixLength) {
      const message = `Function ${runFunction.name}. Multiple matrices with different sizes; [${validatedMatrices[0]}] = ${matrixLength},  [${validatedMatrices[i]}] = ${validatedMatrices[i].length}`;
      throw new import_mathFunctionError.MathFunctionError(message);
    }
  }
  for (let i = 0; i < matrixLength; i += 1) {
    const valuesRow = [];
    for (let j = 0; j < validatedMatrices.length; j += 1) {
      valuesRow.push(validatedMatrices[j][i]);
    }
    resultMatrix[i] = runFunction(...valuesRow);
  }
  return resultMatrix;
};
const operateMatricesTwo = (runFunction, matrix1, matrix2) => {
  if (!Array.isArray(matrix1) && !Array.isArray(matrix2)) {
    return [operateScalars(runFunction, matrix1, matrix2)];
  }
  if (!Array.isArray(matrix1) && Array.isArray(matrix2)) {
    return operateMatrix(runFunction, matrix2, matrix1);
  }
  if (Array.isArray(matrix1) && !Array.isArray(matrix2)) {
    return operateMatrix(runFunction, matrix1, matrix2);
  }
  if (Array.isArray(matrix1) && matrix2.length === 1) {
    return operateMatrix(runFunction, matrix1, matrix2[0]);
  }
  if (matrix1.length === 1 && !Array.isArray(matrix2)) {
    return operateMatrix(runFunction, matrix2, matrix1[0]);
  }
  return operateMultipleMatrices(runFunction, [matrix1, matrix2]);
};
const operateMatrices = (runFunction, ...valueMatrices) => {
  const matrices = valueMatrices.filter((matrix) => {
    return matrix !== void 0;
  });
  if (matrices && Array.isArray(matrices) && matrices.length !== 0) {
    if (matrices.length === 1) {
      return operateMatrix(runFunction, matrices[0]);
    }
    if (matrices.length === 2) {
      return operateMatricesTwo(runFunction, matrices[0], matrices[1]);
    }
    return operateMultipleMatrices(runFunction, matrices);
  }
  return [runFunction()];
};
const operateMatricesOneToMany = (callingFunction, runFunction, valueA, valueB) => {
  if (!Array.isArray(valueB)) {
    const message = `Function ${callingFunction.name}. Operand 2 is not a matrix ${valueB}`;
    throw new import_mathFunctionError.MathFunctionError(message);
  }
  return valueB.map((elementB) => runFunction(valueA, elementB));
};
const simplify = (value) => {
  if (Array.isArray(value) && value.length === 1) {
    return value[0];
  }
  return value;
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  ARG,
  evalArgs,
  fillingValue,
  getCountValue,
  isCondition,
  operateMatrices,
  operateMatricesOneToMany,
  operateMatrix,
  sanitizeNumber,
  sanitizeString,
  simplify,
  uppercaseString
});
